module.exports = __webpack_public_path__ + "img/LBF_logo_blanc.510391b7.png";